import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/authContext";
import { volverAClase } from "../utils/navigation";

const Historial = () => {
  const [entrenos, setEntrenos] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const [confirmMode, setConfirmMode] = useState(false); // 🔹 modo confirmación
  const navigate = useNavigate();
  const { user } = useAuth();


  //Validar que estoy en historial
  useEffect(() => {
    localStorage.setItem("lastPage", "historial");
  }, []);


  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("historialEntrenos")) || [];
    const ordenados = [...data].reverse();
    setEntrenos(ordenados);
  }, []);

  const handleClear = () => {
    localStorage.removeItem("historialEntrenos");
    setEntrenos([]);

    // ✅ mensaje de éxito
    setModalType("success");
    setModalMessage("✅ Historial borrado con éxito");
    setConfirmMode(false);
    setModalOpen(true);
  };

  const openConfirmModal = () => {
    setModalType("error");
    setModalMessage("⚠️ ¿Seguro que deseas borrar el historial?");
    setConfirmMode(true);
    setModalOpen(true);
  };

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex flex-col items-center p-6 text-white">
      <div className="w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center text-green-400">
          📊 Historial de entrenos
        </h1>

        {entrenos.length === 0 ? (
          <p className="text-center text-gray-400 italic">
            Todavía no has guardado ningún entreno.
          </p>
        ) : (
          <ul className="space-y-4">
            {entrenos.map((entreno, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white/10 backdrop-blur-lg rounded-xl p-4 shadow-lg"
              >
                <p>📅 <b>{entreno.fecha}</b></p>
                <p>⏱️ <span className="font-semibold">{entreno.duracion}</span></p>
                <p>🚴 <span className="text-blue-400 font-semibold">{entreno.distancia}</span></p>
                <p>🔥 <span className="text-orange-400 font-semibold">{entreno.calorias}</span></p>
                <p>🎉 {entreno.emojis} emojis lanzados</p>
                <p>🏆 <span className="text-green-400 font-semibold">{entreno.puntos}</span> puntos sesión</p>
                <p>
                  🎯 <span className={`font-semibold ${entreno.modo === "Premium" ? "text-yellow-400" : "text-gray-300"}`}>
                    {entreno.modo === "Premium" ? "Modo Premium" : "Modo Free"}
                  </span>
                </p>

                {/* 👇 Nuevos campos */}
                {entreno.gimnasio && (
                  <p>🏋️ Gimnasio: <span className="font-semibold">{entreno.gimnasio}</span></p>
                )}
                {entreno.claseId && (
                  <p>📌 Clase: <span className="font-semibold">{entreno.claseId}</span></p>
                )}

              </motion.li>
            ))}
          </ul>
        )}

        <div className="mt-8 flex flex-col gap-3">
          <button
            onClick={() => volverAClase(navigate, user?.uid)}
            className="w-full bg-gradient-to-r from-blue-400 to-indigo-600 hover:from-blue-500 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
          >
            Volver
          </button>

          {entrenos.length > 0 && (
            <button
              onClick={openConfirmModal} // 🔹 ahora abre confirmación
              className="w-full bg-gradient-to-r from-red-400 to-red-700 hover:from-red-500 hover:to-red-800 text-white font-semibold py-3 rounded-xl shadow-lg transition"
            >
              Borrar historial
            </button>
          )}
        </div>

        <p className="mt-6 text-center text-gray-300 italic">
          "El progreso se construye entreno a entreno 🚴🔥"
        </p>
      </div>

      {/* 🔹 Modal de confirmación / éxito */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-900 text-white p-6 rounded-2xl shadow-xl w-80 text-center">
            <h2
              className={`text-lg font-bold mb-4 ${modalType === "success" ? "text-green-400" : "text-red-400"
                }`}
            >
              {modalMessage}
            </h2>

            {confirmMode ? (
              <div className="flex justify-center gap-3">
                <button
                  onClick={handleClear}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg shadow-md"
                >
                  Sí, borrar
                </button>
                <button
                  onClick={() => setModalOpen(false)}
                  className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-lg shadow-md"
                >
                  Cancelar
                </button>
              </div>
            ) : (
              <button
                onClick={() => setModalOpen(false)}
                className="mt-3 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg shadow-md"
              >
                Cerrar
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Historial;
